import { ColScaffold, ScaffoldSelection } from "../../interface";
import { buildColRange } from "./buildColRange";

/**
 * Adds a column range to the existing selection without removing other selections.
 *
 * @param selection - The current scaffold selection state.
 * @param cols - All available scaffold columns.
 * @param anchorColId - The column ID of the selection anchor.
 * @param targetColId - The column ID of the target column.
 * @returns A new selection state with the column range merged in.
 */
export const addColRangeToSelection = <T>(
  selection: ScaffoldSelection,
  cols: ColScaffold<T>[],
  anchorColId: string,
  targetColId: string,
): ScaffoldSelection => {
  const rangeItems = buildColRange(cols, anchorColId, targetColId);
  const existingIds = new Set(selection.selectedCols.map((c) => c.firstCellId));
  const newItems = rangeItems.filter((c) => !existingIds.has(c.firstCellId));

  return {
    ...selection,
    selectedCols: [...selection.selectedCols, ...newItems],
  };
};
